import React, { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useHistory } from "react-router-dom";
// import { useHistory } from 'react-router-dom';

import { transaksiJurnalFormData as transaksiJurnalFormDataAkuntan } from "./transaksiJurnalFormData";
import { transaksiJurnalTable as transaksiJurnalTableAkuntan } from "./transaksiJurnalTable";

// Components
import FormCustom from "components/Forms/FormCustom";

// API
import {
  insertNewTransaksiJurnal as insertNewTransaksiJurnalAkuntan,
  getDataTableTransaksiJurnal as getDataTableTransaksiJurnalAkuntan,
  deleteTransaksiJurnal as deleteTransaksiJurnalAkuntan,
} from "./api/transaksiJurnalAPI";
import {
  getDropdownAkunsDebet as getDropdownAkunsDebetAkuntan,
  getDropdownAkunsKredit as getDropdownAkunsKreditAkuntan,
} from "views/akuntan/masterData/kodeAkun/api/kodeAkunAPI";
import { getDropdownUnitUsaha as getDropdownUnitUsahaAkuntan } from "views/akuntan/masterData/unitUsaha/api/unitUsahaAPI";
import CardTable from "components/Cards/CardTable";
import ConfirmModal from "components/Modal/ConfirmModal";

export default function TransaksiJurnalAkuntan() {
  const history = useHistory();

  const [dataTable, setDataTable] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);

  const [typeSearch, setTypeSearch] = useState("");

  const [active, setActive] = useState(false);

  const [formData, setFormData] = useState(null);

  // Select - Option Data
  const [dropdownAkunDebet, setDropdownAkunDebet] = useState([]);
  const [dropdownAkunKredit, setDropdownAkunKredit] = useState([]);
  const [dropdownUnitUsaha, setDropdownUnitUsaha] = useState([]);

  const [formDataArr, setFormDataArr] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [result, setResult] = useState(null);
  const [errors, setErrors] = useState(null);

  const [addForm, setAddForm] = useState(false);

  const [deletePopUp, setDeletePopUp] = useState({ show: false, id: null });

  // Component is Active
  useEffect(() => {
    setActive(true);
    return () => {
      setActive(false);
    };
  }, []);

  // Loading
  useEffect(() => {
    if (isLoading === true) {
      toast.loading("Data Diproses...");
    }
  }, [isLoading]);

  // Handle When State Active Changed
  useEffect(() => {
    setIsLoading(true);

    getDataTableTransaksiJurnalAkuntan()
      .then((response) => {
        active === true && setDataTable(response.data.data);
      })
      .catch((error) => console.error(`Error: ${error}`))
      .finally(setIsLoading(false));

    return () => {
      setDataTable([]);
    };
  }, [active]);

  // Clear Form Data When First Time Load Component
  useEffect(() => {
    setFormData(null);
  }, []);

  // Load Data Table
  useEffect(() => {
    if (active === true) {
      setIsLoading(true);
      getDataTableTransaksiJurnalAkuntan()
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
    }
  }, [active]);

  // Handle Search
  const handleSearch = (e) => {
    setTypeSearch(e.target.value);
  };

  // Handle when searching changes
  useEffect(() => {
    const getDataSearchResult = () => {
      getDataTableTransaksiJurnalAkuntan(typeSearch)
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    const getData = () => {
      getDataTableTransaksiJurnalAkuntan()
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    let timer = setTimeout(() => {
      if (typeSearch) {
        getDataSearchResult();
      } else {
        getData();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [typeSearch]);

  // Handle when Page Change
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  // Handle when user want to add new data
  function handleInsert() {
    setActive(false);
    setAddForm(true);
  }

  // Select-Option Data
  // Load Dropdown Akun Debet
  useEffect(() => {
    setIsLoading(true);

    getDropdownAkunsDebetAkuntan()
      .then((response) => {
        setDropdownAkunDebet(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownAkunDebet([]);
    };
  }, [active]);

  // Load Dropdown Akun Kredit
  useEffect(() => {
    setIsLoading(true);

    getDropdownAkunsKreditAkuntan()
      .then((response) => {
        setDropdownAkunKredit(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownAkunKredit([]);
    };
  }, [active]);

  // Load Dropdown Unit Usaha
  useEffect(() => {
    setIsLoading(true);

    getDropdownUnitUsahaAkuntan()
      .then((response) => {
        setDropdownUnitUsaha(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownUnitUsaha([]);
    };
  }, []);
  // End Select-Option Data

  // Load Form Data Arr
  useEffect(() => {
    setFormDataArr(
      transaksiJurnalFormDataAkuntan(
        dropdownAkunDebet,
        dropdownAkunKredit,
        dropdownUnitUsaha
      )
    );

    return () => {
      setFormDataArr([]);
    };
  }, [dropdownAkunDebet, dropdownAkunKredit, dropdownUnitUsaha]);

  // Set Inputted Data to Form
  const setData = (key, value) => {
    // console.log(formData);
    return setFormData({ ...formData, [key]: value });
  };

  // Handle When User Submit New Data
  const handleInsertSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);

    insertNewTransaksiJurnalAkuntan(formData)
      .then((response) => setResult(response))
      .catch((err) => setErrors(err))
      .finally(endSubmitProcess());
  };

  // Handle When User Click Cancel
  const handleCancelButton = () => {
    setAddForm(false);
    setFormData(null);
    setActive(true);
  };

  // Handle When Submit Process is End
  const endSubmitProcess = () => {
    setDeletePopUp({ show: false });

    setIsLoading(false);
  };

  // Check if Request is Failed
  useEffect(() => {
    if (errors !== null) {
      toast.error(errors.message);
    }
  }, [errors]);

  // Check if request is Success
  useEffect(() => {
    if (result !== null) {
      if (result.data.success === true) {
        toast.success(result.data.message);
        setFormData(null);
        setAddForm(false);
        setActive(true);
        history.push("/transaction/transaksiJurnal");
      } else {
        let numericArray = [];
        for (let err in result.data.errors) {
          numericArray.push(result.data.errors[err]);
        }

        if (numericArray !== []) {
          toast.error(numericArray[0]);
        }
      }
      setResult(null);
    }

    return () => {
      setResult(null);
    };
  }, [history, result]);

  // Handle when user click delete button
  const handleDelete = (rowData) => {
    setDeletePopUp({
      show: true,
      id: rowData.id_transaksi_jurnal,
    });
  };

  // Handle when user confirm to delete data
  const handleDeleteTrue = () => {
    setActive(false);
    if (deletePopUp.show && deletePopUp.id) {
      setIsLoading(true);

      deleteTransaksiJurnalAkuntan(deletePopUp.id)
        .then((response) => setResult(response))
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    }
  };

  // Handle when user deny to confirm delete data
  const handleDeleteFalse = () => {
    setDeletePopUp({ show: false });
  };

  if (addForm === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            <Toaster />
            <FormCustom
              title={"Tambah Data Transaksi Jurnal"}
              formDataArr={formDataArr}
              handleSubmit={handleInsertSubmit}
              handleCancelButton={handleCancelButton}
              setData={setData}
              editFormValue={null}
            />
          </div>
        </div>
      </div>
    );

  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          {deletePopUp.show && (
            <div>
              <ConfirmModal
                handleIfTrue={(e) => handleDeleteTrue()}
                handleIfFalse={(e) => handleDeleteFalse()}
              />
            </div>
          )}
          <Toaster />
          <CardTable
            tableTitle="Tabel Transaksi Jurnal"
            cols={transaksiJurnalTableAkuntan(handleDelete)}
            handleInsert={(e) => handleInsert()}
            data={dataTable}
            handleSearch={handleSearch}
            pageNumber={pageNumber}
            changePage={changePage}
          />
        </div>
      </div>
    </div>
  );
}
